<template>
  <div>
    <main>
      <Banner />
      <PdkHeader />
      <PdkSideMenu :menuList="menuList" />
    </main>
  </div>
</template>


<script>
import Banner from "@/components/tour/TourBanner";
import PdkHeader from "@/components/shared/PdkSubHeader";
import PdkFooter from "@/components/shared/PdkSubFooter";
import PdkSideMenu from "@/components/shared/PdkSideMenu";

export default {
  name: "Profile",
  components: { PdkHeader, Banner, PdkFooter, PdkSideMenu },
  data: function () {
    return {
      tabIndex: 0,
      profileId: "",
      sources: [],
      selectedSource: "",
      profileAccessibility: [],
      menuList: [],
    };
  },
  created() {
    this.getAccessibility();
  },
  methods: {
    getAccessibility() {
      this.menuList = JSON.parse(localStorage.getItem("menuList"));

      if (this.menuList.length != 0) {
        this.menuList = this.menuList.filter(
          (p) => p.name === "customerClub"
        )[0].children;
        this.menuList.sort(function (a, b) {
          return a.sortId - b.sortId;
        });
      }

      return this.menuList;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.margin_60 {
  padding-top: 60px;
  padding-bottom: 60px;
}
ul#cat_nav li a {
  position: relative;
  color: #777;
}
ul#cat_nav li a:after {
  font-family: fontello;
  content: "";
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 13px !important;
}
.selected-item {
  background: #d5ac40;
  color: #fff;
  font-size: 13px;
  text-align: center;
  padding: 2px;
  border-radius: 3px;
}
.router-link-exact-active {
  /* color: #111  !important; */
  color: #08446a !important;
}

.score-management {
  background-color: #ededed;
  color: black;
}
.progress-box {
  background-color: lightgrey;
  width: 90%;
  /* width: 320px; */
  height: 5px;
}
.progress-bar {
  height: 5px;
}
.progress-bar1 {
  background-color: green;
  width: 60% !important;
}
.progress-bar2 {
  background-color: fuchsia;
  width: 70px !important;
}
.progress-bar3 {
  background-color: blue;
  width: 100px !important;
}
.bt-3 {
  margin-top: 2rem !important;
}
/* ********** leftside cards style : end ********** */
.router-link-active {
  position: relative;
}
</style>
